/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const bulkUpdateThankYouScreenItemDataSchema = z.object({
	id: z.string().uuid(),
	title: z.string(),
	description: z.string(),
	meta: z.array(z.string()).nullable().optional(),
})

export type BulkUpdateThankYouScreenItemDataSchema = z.infer<typeof bulkUpdateThankYouScreenItemDataSchema>
